export const USER_LOGIN = "USER_LOGIN";
export const USER_LOGOUT = "USER_LOGOUT";
export const OPEN_LEFT_MENU = "OPEN_LEFT_MENU";
export const SET_REDIRECT_URL = "SET_REDIRECT_URL";
export const CLOSE_LEFT_MENU = "CLOSE_LEFT_MENU";






// WEBPACK FOOTER //
// ./src/constant.js